

        eventChange('.calculate-duty-currency', function () {

            const currency = $('.calculate-duty-currency').val();
            const amount = $('.calculator-duty-price').val();

            checkIfNumeric(amount);

            request('GET', `${route('calculator_duty')}?currency=${currency}&amount=${amount}`, function (response) {

                const currency_symbol = response.currency_sign;

                $('#price_usd').text(`${currency_symbol}${response.price_currency}`);
                $('#price_rub').text(response.price_rub);

                $('#fixed_price_usd').text(`${currency_symbol}${response.extra_charge_currency}`);
                $('#fixed_price_rub').text(response.extra_charge_rub);

                $('#fix_by_price_usd').text(`${currency_symbol}${response.duty_amount_currency}`);
                $('#fix_by_price_rub').text(response.duty_amount_rub);

                $('#total_price_with_duty_usd').text(`${currency_symbol}${response.total_price_currency}`);
                $('#total_price_with_duty_rub').text(response.total_price_rub);

                $('#broker_usd').text(`${currency_symbol}${response.broker_amount_currency}`)
                $('#broker_rub').text(response.broker_amount_rub)
            })

        })

        eventChange('.calculator-duty-price', function () {

            const currency = $('.calculate-duty-currency').val();
            const amount = $('.calculator-duty-price').val();

            checkIfNumeric(amount);

            request('GET', `${route('calculator_duty')}?currency=${currency}&amount=${amount}`, function (response) {

                const currency_symbol = response.currency_sign;

                $('#price_usd').text(`${currency_symbol}${response.price_currency}`);
                $('#price_rub').text(response.price_rub);

                $('#fixed_price_usd').text(`${currency_symbol}${response.extra_charge_currency}`);
                $('#fixed_price_rub').text(response.extra_charge_rub);

                $('#fix_by_price_usd').text(`${currency_symbol}${response.duty_amount_currency}`);
                $('#fix_by_price_rub').text(response.duty_amount_rub);

                $('#total_price_with_duty_usd').text(`${currency_symbol}${response.total_price_currency}`);
                $('#total_price_with_duty_rub').text(response.total_price_rub);

                $('#broker_usd').text(`${currency_symbol}${response.broker_amount_currency}`)
                $('#broker_rub').text(response.broker_amount_rub)
            })
        });


        eventClick('.calc-duty-price', function (){

            const currency = $('.calculate-duty-currency').val();
            const amount = $('.calculator-duty-price').val();

            checkIfNumeric(amount);

            request('GET', `?currency=${currency}&amount=${amount}`, function (response) {

                const currency_symbol = response.currency_sign;

                $('#price_usd').text(`${currency_symbol}${response.price_currency}`);
                $('#price_rub').text(response.price_rub);

                $('#fixed_price_usd').text(`${currency_symbol}${response.extra_charge_currency}`);
                $('#fixed_price_rub').text(response.extra_charge_rub);

                $('#fix_by_price_usd').text(`${currency_symbol}${response.duty_amount_currency}`);
                $('#fix_by_price_rub').text(response.duty_amount_rub);

                $('#total_price_with_duty_usd').text(`${currency_symbol}${response.total_price_currency}`);
                $('#total_price_with_duty_rub').text(response.total_price_rub);

                $('#broker_usd').text(`${currency_symbol}${response.broker_amount_currency}`)
                $('#broker_rub').text(response.broker_amount_rub)
            })
        })

        /**
         * Проверка является ли введенное значение цифрой
         */
        function checkIfNumeric(value){
            if (!$.isNumeric(value)){
                showError('Введите правильную стоимость');
                return false;
            }
        }
